














import {Component, Prop, Vue} from "vue-property-decorator";
import SidebarContent from "./SidebarContent.vue";

@Component({
    name: 'SidebarMobile',
    components: { SidebarContent }
})
export default class extends Vue {
    private placement = 'left';
    private bodyStyle = {
        padding: 0
    };

    private drawerStyle = {
        background: "#001529"
    };

    @Prop({ required: true })
    private visible!: boolean;

    get _visible() {
        return this.visible;
    }

    private onClose() {
        this.$emit('closeSidebar');
    }

}
